export const serviceName = 'entityActions';
